<template>
  <div>
    <h2 class="text-center font-weight-medium">
      Nhóm Sản Phẩm Nông Nghiệp
    </h2>
    <v-row justify="center" class="pa-10">
      <v-col 
        cols="12" 
        md="3" 
        v-for="(pg, index) in productGroups" 
        :key="`group${index}`"
      >
        <v-card
          :to="pg.to"
          align="center"
          color="#F9FAFC"
          class="rounded-circle border pt-10 mx-auto"
          width="220"
          height="220"
          flat
        >
          <v-icon size="60" color="primary">
            {{pg.icon}}
          </v-icon>

          <v-card-text class="orange--text text--accent-3 text-lg-h6">
            {{ pg.name }}
          </v-card-text>

          <v-btn
            v-if="$vuetify.breakpoint.lgAndUp"
            absolute
            color="primary"
            class="white--text"
            fab
            left
            top
            :loading="pg.spin"
          >
            <h2>{{ pg.sl }}</h2>
          </v-btn>
          <v-chip 
            v-else 
            class="px-8 white--text"
            color="primary"
            outlined
          >
            <strong>{{ pg.sl }}</strong>
          </v-chip>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-4">
        <p class="text-center">
          Danh mục được cung cấp bởi 
          <v-icon>mdi-check</v-icon> <strong>Chi cục quản lý chất lượng</strong>, 
          <v-icon>mdi-check</v-icon> <strong>Chi cục trồng trọt & bảo vệ thực vật</strong>, 
          <v-icon>mdi-check</v-icon> <strong>Chi cục chăn nuôi & thú y</strong>, và 
          <v-icon>mdi-check</v-icon> <strong>Chi cục phát triển nông thôn</strong> 
          Tỉnh Tiền Giang
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        productGroups: [
          {
            id: 1, 
            name: 'Sản phẩm đặc sản', 
            key: 'dacs', 
            sl: 0, 
            to: '/products/special/tree', 
            spin: true,
            icon: 'mdi-fruit-pineapple'
          },
          {
            id: 2, 
            name: 'Sản phẩm chuỗi', 
            key: 'attp', 
            sl: 0, 
            to: '/products/chain', 
            spin: true,
            icon: 'mdi-compost'
          },
          {
            id: 3, 
            name: 'Sản phẩm OCOP', 
            key: 'ocop', 
            sl: 0, 
            to: '/products/ocop', 
            spin: true,
            icon: 'mdi-medal-outline'
          },
          {
            id: 4, 
            name: 'Sản phẩm truy xuất', 
            key: 'tx', 
            sl: 0, 
            to: '/products/tracing', 
            spin: true,
            icon: 'mdi-cube-scan'
          }
        ],
        crumbs: []
      }
    },
    mounted () {
      this.countOcopProduct();
      this.countChainProduct();
      this.countSpecialProduct();
      this.countTraceProduct();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Nhóm sản phẩm nông nghiệp',
          disabled: true
        }
      ];
    },
    methods: {
      countOcopProduct () {
        const app = this;
        axios.get("api/v1/public/count-ocop-product")
          .then(response => {
            let objIndex = app.productGroups.findIndex((obj => obj.key === 'ocop'));
            app.productGroups[objIndex].sl = response.data;
            app.productGroups[objIndex].spin = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      countChainProduct () {
        const app = this;
        axios.get("api/v1/public/product-chains-count")
          .then(response => {
            let objIndex = app.productGroups.findIndex((obj => obj.key === 'attp'));
            app.productGroups[objIndex].sl = response.data;
            app.productGroups[objIndex].spin = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      countSpecialProduct () {
        const app = this;
        axios.get("api/v1/public/count-special-product")
          .then(response => {
            let objIndex = app.productGroups.findIndex((obj => obj.key === 'dacs'));
            app.productGroups[objIndex].sl = response.data;
            app.productGroups[objIndex].spin = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      countTraceProduct() {
        const app = this;
        axios.get("api/v1/public/count-trace-product")
          .then(response => {
            let objIndex = app.productGroups.findIndex((obj => obj.key === 'tx'));
            app.productGroups[objIndex].sl = response.data;
            app.productGroups[objIndex].spin = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>
<style scoped>
.text-lg-h6{
  font-family: 'Times New Roman', serif !important;
}
.border {
  border: 2px solid #00796b !important;
}
.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
  top: 65px !important;
}
.v-btn--absolute.v-btn--left,
.v-btn--fixed.v-btn--left {
  left: -26px !important;
}
</style>